angular.
module("dx.webapp.wordGap").
component("dxWordGapCorrectAnswers", {
	templateUrl: "tmpl/word-gap/word-gap-correct-answers-component.html",
	controller: "DxWordGapCorrectAnswersController",
	controllerAs: "vm",
	bindings: {
		question: "<",
	},
});
